import React from 'react'
import DialogActions from '@mui/material/DialogActions'

interface DialogActionButtonsProps {
  children: React.ReactNode // Define the type for children
}

const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({ children }) => {
  return <DialogActions>{children}</DialogActions>
}

export default DialogActionButtons
